// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ei","articleImagesWrap":"fi","articleImage":"gi","singleImage":"hi"};